module.exports = __webpack_public_path__ + "static/img/winners-third.fa30c0d4.jpg";